import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { useDispatch, useSelector } from "react-redux";
/* eslint no-use-before-define: 0 */
// import { connectWallet } from "./redux/WalletAction";
import './App.css';

import CommonRoutes from './Routes/CommonRoutes';
import SplashScreen from './Components/SplashScreen/SplashScreen';

import { Web3ModalProvider } from './WagmiProvider/Web3ModalProvider';

const App = () => {
  // eslint-disable-next-line
  const [Loader, setLoader] = useState(true);

  useEffect(() => {
    if (Loader) {
      setTimeout(() => {
        setLoader(false);
      }, 3000);
    }
  }, [Loader]);



  return (
    <Web3ModalProvider>
      <div className="App">
        {Loader ? <SplashScreen /> : <CommonRoutes />}

        <ToastContainer
          position="bottom-right"
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          toastStyle={{
            fontFamily: 'PoppinsMedium',
            fontSize: '13px',
            textAlign: 'left',
            color: '#FFF',
            background: 'linear-gradient(66deg, #BF0F67 0%, #0A0D6B 77%)',
          }}
        />
      </div>
    </Web3ModalProvider>
  );
};

export default App;
